import Vue from 'vue'
import Router from 'vue-router'
import Main from '@components/main/main'
// 用户管理
import userCenter from '@/pages/userCenter'
// 基本设置
import basicSet from '@/pages/baseInfoSet'
// 药商管理、药房管理、药品管理
import pharmacyManageRouter from '@/pages/pharmacyManage'
// 处方发货管理及处方订单管理
import prescriptionDrug from '@/pages/prescriptionDrug'
// 极速开方
import quickPrescribe from '@/pages/quickPrescribe'

// erp推单列表
import erpChargebackList from '@/pages/erpChargebackList'
Vue.use(Router)

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@pages/login/pages/login'),
      meta: {
        title: '登录',
        auth: false
      }
    },
    {
      path: '/',
      component: Main,
      // redirect: '/home',
      redirect: '/home',
      children: [
        {
          name: 'home',
          path: '/home',
          component: () => import('@pages/home/pages/home'),
          meta: {
            auth: true
          }
        }
      ]
    },
    // 用户管理
    userCenter,
    // 基本设置
    basicSet,
    // 药商管理、药房管理、药品管理
    pharmacyManageRouter,
    // 处方发货及处方订单
    prescriptionDrug,
    // 极速开方
    quickPrescribe,
    // erp推单列表
    erpChargebackList,
    {
      path: '*',
      name: 'noPage',
      component: () => import('@pages/noPage/noPage'),
      meta: {
        title: '页面不存在',
        auth: false
      }
    }
  ]
})

/**
 * @description 路由守卫
 */
// 全局钩子函数
// to: Route: 即将要进入的目标 路由对象
// from: Route: 当前导航正要离开的路由
// next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
// next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
// next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
// next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
// 确保要调用 next 方法，否则钩子就不会被 resolved。

router.beforeEach(async(to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 判断是否需要登录权限，登录拦截
  if (to.matched.some(res => res.meta.auth)) {
    const hospitalUserInfo = JSON.parse(localStorage.getItem('userInfo')) || ''
    const adminMenuRouter = JSON.parse(localStorage.getItem('ADMIN_MENU_ROUTER')) || ['/home']
    const hasRoute = adminMenuRouter.includes(to.path)

    // 判断左侧权限菜单中是否包含地址栏菜单
    if (!hospitalUserInfo || !adminMenuRouter.length) {
      next({ path: '/login' })
    } else {
      if (hasRoute) {
        next()
      } else {
        next({ path: '*' })
      }
    }
  } else {
    next()
  }
})
// router.afterEach((to, from) => {
//   //跳转后你要做的事情
//   // console.log("路由跳转后：", to, from);
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js